import React from 'react';
import { ServerService } from './../../../services/server.service';
import { ImageService } from './../../../services/image.service';
import $ from 'jquery';
import ReactToolTip from 'react-tooltip';
import { dateInUTC, formatBytesFloat, removeSpecialCharacter } from '../../../utility/utility';
import { AuditLog } from './../../../services/auditlog.service';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from '../../../constants/server.constant';
import Axios from 'axios';
import { loginService } from '../../../services/login.service';
import { RegionService } from './../../../services/region.service';
import ScrollArea from 'react-scrollbar';

class Snapshot extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            snapshotName: "",
            livesnapshot: "",
            snapshots: [],
            enablesnapshotoptions: false,
            isdatapresent: false,
            selectedRowId: '',
            nonActiveSnapshots: [],
            selectedSnapshot: {},
            nameToggle: false,
            sizeToggle: false,
            statusToggle: false,
            datetoggle: false,
            columnName: 'date',
            isAction: false,
            isdisabled: false,
            createInstDisabled: false,
            isAddRegSlider: false,
            uploadRegion: "",
            regionList: [],
            regionListFilter: [],
            regionContainerFocus: false,
            regionid: ""
        };

    }
    componentDidMount() {
        $("main").removeClass("ls_expand");
        $("html").animate({ scrollTop: 0 }, "slow");
        this.getMaintananceRegions();
        this.getSnapshotList('loading');
        this.loadRegions();
        this.setState({ snapshotName: this.getInitialSnapshotName() });
    }

    getMaintananceRegions() {
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + "/regions/maintainance/" + userId, axiosRequestWithAuth).
            then(resp => {
                let res = resp.data;
                if(res && res.length > 0) {
                    let ob = res.find(item => item.region_id === this.props.regionName);
                    if(ob !== undefined) {
                        this.setState({
                            createInstDisabled: true
                        });
                    }
                }
                this.setState({
                    regionMaintList: res
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    getInitialSnapshotName() {
        return removeSpecialCharacter(this.props.instance.name) + '-' + dateInUTC();
    }

    activateActionMenu() {

        sessionStorage.isInstanceLoaded = "true";
        var documentwindowHeight = $(document).height();
        $('.dashboard_module .table_data .tr .row_menu_icon, .tabular_data_wrap li .menu_icon').click(function () {
            $('.tabular_data_wrap .table_data .tr').removeClass('active');
            $(this).closest('.tr').addClass('active');
            //$(this).closest('.dashboard_module .tr').find('.dropdown_component').toggleClass('active');
            $(this).find('.dropdown_component').css({ top: '30px' });
            var fmi = 'dropdown_component';
            var offset = $(this).offset();
            var x = (offset.left);
            var y = (offset.top);
            var windowHeight = $(window).height();
            var menuHeight = $(this).find('.' + fmi).height();
            var totalHeight = menuHeight + y;
            if(documentwindowHeight < totalHeight) {
                $('.' + fmi).css({ top: -Math.abs(menuHeight + 10) });
                $('.arrow_pointer').addClass('bottom_arrow');
            }
            else if(documentwindowHeight > totalHeight) {
                totalHeight = totalHeight - windowHeight;
                totalHeight = totalHeight + 50;
                $('.arrow_pointer').removeClass('bottom_arrow');

                window.scrollTo({ top: totalHeight, behavior: 'smooth', });
            }
        });
    }

    getSnapshotList(action) {
        localStorage.removeItem("serverlist");

        if(action === 'loading') {
            this.props.bgShadowHandler(true);
        }
        ImageService.getAllImageDetailsByType(this.props.imageRegionUrl, this.props.instanceId, 'snapshot').then(resp => {
            if(action === 'loading') {
                this.props.bgShadowHandler(false);
            }
            if(resp.images) {
                let nonActiveSnapshotArr = [];
                let activeSnapshotArr = [];
                resp.images.forEach(image => {
                    if(image.status === 'active') {
                        activeSnapshotArr.push(image);
                    } else {
                        nonActiveSnapshotArr.push(image);
                    }
                });
                this.setState({ nonActiveSnapshots: nonActiveSnapshotArr, snapshots: this.getSortable(this.state.columnName, activeSnapshotArr, false) }, () => this.activateActionMenu());
                let docElem = document.getElementById("snapshotName");
                if(docElem !== null) {
                    docElem.focus();
                }
                // if (nonActiveSnapshotArr.length == 0) {
                //     this.setState({ snapshots: this.getSortable(this.state.columnName, activeSnapshotArr, false), nonActiveSnapshots: nonActiveSnapshotArr });
                // }
                if(nonActiveSnapshotArr.length > 0) {
                    let geturl = window.location.href;
                    if(geturl.indexOf("snapshots") !== -1) {
                        this.setState({ isdisabled: true });
                        sessionStorage.snapTimeout = setTimeout(() => this.getSnapshotList('none'), 10000);
                    }
                } else {
                    this.setState({ isdisabled: false });
                }
            }
        });
    }

    isSnapshotCreateReady() {
        let isActive = true;
        let nonActiveSnapshots = this.state.nonActiveSnapshots;
        for(let i = 0; i < nonActiveSnapshots.length; i++) {
            if(nonActiveSnapshots[i].status !== 'active') {
                isActive = false;
                break;
            }
        }
        return isActive;
    }

    isNameExist = (name) => {
        let ob = this.state.snapshots.find(item => item.name === name.trim());
        if(ob !== undefined) {
            return true;
        }
        return false;
    };

    createSnapshot = () => {
        if(this.state.isAction) {
            return;
        }
        if(this.state.snapshotName === undefined || this.state.snapshotName.trim() === '') {
            this.setState({ errorMessg: 'Name cannot be blank', snapshotName: this.state.snapshotName.trim() });
            document.getElementById("snapshotName").focus();
            return;
        }
        if(!this.isSnapshotCreateReady()) {
            this.setState({ errorMessg: 'Cannot process new request until the present snapshot is created' });
            document.getElementById("snapshotName").focus();
            return;
        }
        if(this.isNameExist(this.state.snapshotName)) {
            this.setState({ errorMessg: 'Name cannot be duplicate' });
            document.getElementById("snapshotName").focus();
            return;
        }
        var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
        if(!nameRegex.test(this.state.snapshotName)) {
            document.getElementById('snapshotName').focus();
            this.setState({ errorMessg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)' });
            return false;
        }
        let requestBody = { createImage: {} };
        requestBody.createImage.name = this.state.snapshotName.trim();
        let logSnapshotName = this.state.snapshotName.trim();
        let logRegion = this.props.instance.region;
        this.props.bgShadowHandler(true);
        this.setState({ isAction: true, isdisabled: true });
        let i18n = this.props.i18n;
        ServerService.serverAction(this.props.instanceId, this.props.computeRegionUrl, requestBody).then(resp => {
            if(resp === '') {
                const addSnapshot = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Snapshot " + logSnapshotName + " has been added",
                    "operation": "Snapshot Added",
                    "region": logRegion
                };
                AuditLog.storeAuditLogs(addSnapshot, "instance").then((resp) => {
                    if(resp === false);
                });
                this.props.disableBttn();
                this.props.doInstTaskStateCheck();
                this.getSnapshotList('create');
                this.setState({ snapshotName: this.getInitialSnapshotName(), isAction: false });
                this.props.msgHandler(i18n.t('inst_snap_create_success'), 'success');
                this.props.bgShadowHandler(false);
                this.clearToastMessage();
                localStorage.removeItem("serverlist");
                return;
            }
            this.props.bgShadowHandler(false);
            this.setState({ isAction: false, isdisabled: false });
            this.props.msgHandler(i18n.t('inst_snap_create_failure'), 'error');
            this.clearToastMessage();

        }).catch(error => {
            this.props.bgShadowHandler(false);
            this.setState({ isAction: false, isdisabled: false });
            if(error?.response?.status === 403 && String(error?.response?.data?.message).toLowerCase().startsWith("policy")) {
                this.props.msgHandler(i18n.t('inst_snap_suspended_failure'), 'error');
                this.clearToastMessage();
                return;
            }
            this.props.msgHandler(i18n.t('inst_snap_create_failure'), 'error');
            this.clearToastMessage();
        });
    };

    handleinputs = (event) => {
        let name = event.target.name;
        let val = event.target.value;

        var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
        if(!nameRegex.test(val)) {
            this.setState({ [name]: val, errorMessg: 'Name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)' });
            return;
        }
        if(val.length > 50) {
            return;
        }
        this.setState({ [name]: val, errorMessg: '' });
    };

    enableSnapshotOption = (event) => {
        $(event.currentTarget).find('.dropdown_component').addClass('active');
    };


    deleteSnapshot = () => {
        this.delSnapClose();
        this.props.bgShadowHandler(true);
        let selectedSnapshot = this.state.selectedSnapshot;
        let logRegion = this.props.instance.region;
        let i18n = this.props.i18n;
        ImageService.deleteImageById(this.props.imageRegionUrl, selectedSnapshot.id).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp) {
                const deleteSnapshot = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Snapshot " + selectedSnapshot.name + " has been deleted",
                    "operation": "Snapshot Deleted",
                    "region": logRegion
                };
                AuditLog.storeAuditLogs(deleteSnapshot, "instance").then((resp) => {
                    if(resp === false);
                });
                let filtSnapshots = this.state.snapshots.filter(item => item.id !== selectedSnapshot.id);
                this.setState({ snapshots: filtSnapshots });
                this.props.msgHandler(i18n.t('inst_snap_delete_success'), 'success');
                this.clearToastMessage();
                return;
            }
            this.props.msgHandler(i18n.t('inst_snap_delete_failure'), 'error');
            this.clearToastMessage();
        });
    };

    createInstance = (elem) => {
        elem.isSelected = true;
        this.props.history.push({
            pathname: "/create",
            state: {
                image: { ...elem },
                regionName: this.props.regionName
            }
        });
    };

    downloadAction = (event, snapshot) => {
        this.setState({ selectedRowId: snapshot.id });
        $(event.currentTarget).find('.dropdown_component').removeClass('active');
        let url = ImageService.downloadImageById(this.props.regionName, snapshot.id, snapshot.name);
        loginService.tryRefresh().then(() => {
            window.location.href = url;
        }).catch(err => {
            return;
        });
    };
    snapKeyDown = (e) => {
        if(e.keyCode == 13) {
            this.createSnapshot();
        }
    };
    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };
    setSortable(type) {
        this.setState(this.setState({ snapshots: this.getSortable(type, this.state.snapshots, true) }));
    }
    getSortable = (type, items, isTrue) => {
        if(items && items.length === 0) {
            return items;
        }
        this.setState({ columnName: type });
        if(type === "name") {
            if(this.state.nameToggle) {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                });
            } else {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                    return 0;
                });
            }
            if(isTrue) {
                this.setState({ nameToggle: !this.state.nameToggle });
            }
            return items;
        } else if(type === "status") {
            if(this.state.statusToggle) {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return -1; }
                    if(a.status > b.status) { return 1; }
                    return 0;
                });
            } else {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return 1; }
                    if(a.status > b.status) { return -1; }
                    return 0;
                });
            }
            this.setState({ statusToggle: !this.state.statusToggle });
            return items;
        } else if(type === "date") {
            if(this.state.datetoggle) {
                items.sort(function (a, b) {
                    return new Date(a.created_at) - new Date(b.created_at);
                });
            }
            else {
                items.sort(function (a, b) {
                    return new Date(b.created_at) - new Date(a.created_at);
                });
            }
            this.setState({ datetoggle: !this.state.datetoggle });
            return items;
        } else if(type === "size") {
            if(this.state.sizeToggle) {
                items.sort(function (a, b) {
                    return b.size - a.size;
                });
            } else {
                items.sort(function (a, b) {
                    return a.size - b.size;
                });
            }
            this.setState({ sizeToggle: !this.state.sizeToggle });
            return items;
        }
    };
    componentWillUnmount() {
        clearTimeout(sessionStorage.snapTimeout);
        this.props.msgHandler("");
    }
    clearToastMessage = () => {
        setTimeout(() => {
            this.props.msgHandler("");
        }, 10000);
    };
    delSnapClick(snapshot) {
        this.setState({ selectedSnapshot: snapshot });
        $('#snapDelPoup').addClass('active');
        document.getElementById('snapDelBtn').focus();
    }
    delSnapClose() {
        $('#snapDelPoup').removeClass('active');
    }
    loadRegions = () => {
        RegionService.getAll().then((resp) => {
            console.log(resp);
            if(resp === false) {
                this.setState({
                    regionListFilter: []
                });
            }
            this.setState({
                regionList: resp
            });
        });

    };
    getRegionDropdown = () => {
        $(".regionSelect_options").addClass("active");
        this.setState({
            regionListFilter: this.state.regionList,
            uploadRegion: "",
            isregionselected: false
        });
    };
    filterDropDown = (event) => {
        $(".regionSelect_options").addClass("active");

        let name = event.target.name;
        let val = event.target.value;

        this.setState({
            regionListFilter: this.state.regionList.filter(item => item.name.toLowerCase().includes(val.toLowerCase())),
            uploadRegion: val

        });

    };

    getSelectedRegion = (event, regionOb) => {
        if(regionOb.status !== 1) {
            return;
        }
        $(".regionSelect_options").removeClass("active");
        this.setState({
            uploadRegion: regionOb.name,
            regionid: regionOb.id,
            isregionselected: true,
            countryName: regionOb.countryName,
            regionempty: false
        });

    };
    copyToRegion = (snapshot) => {
        $(".regionSelect_options").removeClass("active");
        this.setState({
            isAddRegSlider: true,
            copyImageId: snapshot.id,
            copyImageRegion: this.props.instance.region,
            copyImageName: snapshot.name,
            uploadRegion: "",
            regionid: "",
            countryName: "",
            regionempty: false
        });
    };
    callCopyRegion = () => {
        if(this.state.regionid.length <= 0) {
            this.setState({
                regionempty: true
            });
            return;
        }
        this.props.bgShadowHandler(true);
        this.setState({
            isAddRegSlider: false
        });
        ImageService.copyImageToReg(this.state.copyImageId, this.state.copyImageRegion, this.state.regionid, this.state.copyImageName)
            .then(resp => {
                if(resp === false) {
                    this.props.bgShadowHandler(false);
                    this.setState({
                        message: "Image copy intiation failed, please try after some time.",
                        msgType: "error"
                    });
                    return;
                }
                this.props.bgShadowHandler(false);
                this.props.msgHandler("Copying image from region " + this.state.copyImageRegion + " to " + this.state.regionid + " and it will be available under custom images");
                this.props.msgType("success");
                this.clearToastMessage();
            })
            .catch(error => {
                console.log(error);
            });
    };

    render() {


        return (
            <div>
                <section className={ this.state.isdatapresent ? "settingModule_wrapper" : "settingModule_wrapper snapshot_setting_module" }>
                    { this.state.isdatapresent ? <div>
                        <div className="outer_empty_wrap">
                            <div className="inner_empty_wrap">
                                <div className="svg_wrap empty_icon snapshot_empty"></div>
                                <p className="empty_title">No Snapshots</p>
                            </div>
                        </div>
                    </div> :
                        <div>
                            <div className="settModule_head_wrap">
                                <div className="settModule_head_lhs">
                                    <h2>Snapshots</h2>
                                    <p className="head_info">Create a real-time copy of the instance with all its contents to restore it to a specific point in time or create a new instance.<br></br> Snapshots are billed per month at <b>$0.05/GB</b>.</p>
                                </div>
                            </div>
                            <div className="snapshotModule_wrap">
                                <div className="snapshotDetail_fields">
                                    <div className="common_txtBox_row snapshot_name">
                                        <label>Provide a snapshot name</label>
                                        <div className="txtBox_wrap hide">
                                            <input id="snapshotName" type="text" name="snapshotName" className="txtBox" placeholder="" value={ this.state.snapshotName } autoComplete="off"
                                                onChange={ (e) => this.handleinputs(e) } onKeyDown={ (e) => this.snapKeyDown(e) } ></input>
                                            <span className="comm_error_msg">{ this.state.errorMessg }</span>
                                        </div>

                                        <input disabled={ this.state.isdisabled } className={ this.state.isdisabled ? "common_cta_btn blue disabled" : "common_cta_btn blue" }
                                            type="button"
                                            name=""
                                            value="Take a live snapshot"
                                            onClick={ () => this.createSnapshot() }></input>
                                    </div>
                                </div>
                                <div className="snapshot_table">
                                    <div className="tabular_data_wrap">
                                        <div className="table_header">
                                            <ul>
                                                <li className="th">
                                                    <div className="col col1">
                                                        <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("name"); } }>Name<span className="sort_icon"></span>
                                                        </div>
                                                    </div>
                                                    <div className="col col2">
                                                        <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("date"); } }>Created On<span className="sort_icon active"></span>
                                                        </div>
                                                    </div>
                                                    <div className="col col3">
                                                        <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("status"); } }>Status<span className="sort_icon"></span>
                                                        </div>
                                                    </div>
                                                    <div className="col col4">
                                                        <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("size"); } }>Size<span className="sort_icon"></span>
                                                        </div>
                                                    </div>
                                                    <div className="col col5">Actions</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="table_data">
                                            <ul>{ this.state.snapshots.length === 0
                                                && this.state.nonActiveSnapshots.length === 0 ? <li>
                                                <div className="inner_empty_wrap">
                                                    <div className={ "svg_wrap empty_icon summary_empty snapshot_empty" }></div>
                                                    <p className="empty_title">Save a point-in-time copy of a compute instance for restoring it to a previous state or for new instance creation.</p>
                                                </div></li> : this.state.snapshots.map((snapshot, i) =>
                                                    <li className="tr" key={ i }>
                                                        <div className="col col1"><span data-tip data-for={ snapshot.name }>{ snapshot.name }</span><ReactToolTip id={ snapshot.name } effect="solid">{ snapshot.name } </ReactToolTip></div>
                                                        <div className="col col2">{ snapshot.created_at }</div>
                                                        <div className="col col3">{ snapshot.status }</div>
                                                        <div className="col col4">{ formatBytesFloat(snapshot.size) }</div>
                                                        <div className="col col5">
                                                            <span className="icon menu_icon" onClick={ (e) => this.enableSnapshotOption(e) }>
                                                                <svg
                                                                    className="horizMenuIcon"
                                                                    x="0px"
                                                                    y="0px"
                                                                    viewBox="0 0 22.1 6.3"
                                                                    enableBackground="new 0 0 22.1 6.3"
                                                                    xmlSpace="preserve">
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        clipRule="evenodd"
                                                                        fill="#8692B0"
                                                                        d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                </svg>
                                                                <ul className="dropdown_component snapshot_rowOption_dropdown" style={ { textAlign: 'initial', right: '-20px', top: '30px' } }>
                                                                    <span className="arrow_pointer"></span>
                                                                    <li style={ { display: this.state.createInstDisabled || (this.state.regionList && !this.state.regionList.find(elem => elem.id === this.props.instance.region)) ? 'none' : '' } }
                                                                        className="create_instance"
                                                                        data-id="Ubuntu_app_West_John"
                                                                        onClick={ () => this.createInstance(snapshot) }>
                                                                        <span className="icon">
                                                                            <svg
                                                                                x="0px"
                                                                                y="0px"
                                                                                viewBox="0 0 512 512"
                                                                                enableBackground="new 0 0 512 512"
                                                                                xmlSpace="preserve">
                                                                                <path
                                                                                    fillRule="evenodd"
                                                                                    clipRule="evenodd"
                                                                                    fill="#4C8CCD"
                                                                                    d="M448.8,287.9H288.5v160.3c0,17.7-14.4,32.1-32.1,32.1l0,0  c-17.7,0-32.1-14.4-32.1-32.1V287.9H64.1c-17.7,0-32.1-14.4-32.1-32.1s14.4-32.1,32.1-32.1h160.3V63.5c0-17.7,14.4-32.1,32.1-32.1  l0,0c17.7,0,32.1,14.4,32.1,32.1v160.3h160.3c17.7,0,32.1,14.4,32.1,32.1S466.5,287.9,448.8,287.9z" />
                                                                            </svg>
                                                                        </span>Create an instance</li>

                                                                    <li className="regionSlider" onClick={ () => this.copyToRegion(snapshot) }>
                                                                        <span className="icon">
                                                                            <span className="svg_wrap">
                                                                                <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" enableBackground="new 0 0 22.7 22.7" xmlSpace="preserve">
                                                                                    <g>
                                                                                        <path className="rn0" d="M17.9,8.2c0,1.5-0.5,2.8-1.3,3.9l-5,8.9c-0.1,0.2-0.4,0.2-0.5,0l-5-8.9c-0.8-1.1-1.3-2.4-1.3-3.9
                                                                                             c0-3.9,3.4-7,7.4-6.5C15.5,2,17.9,4.8,17.9,8.2z"></path>
                                                                                        <circle className="rn0" cx="11.3" cy="8" r="2.6"></circle>
                                                                                    </g>
                                                                                </svg>
                                                                            </span>
                                                                        </span>Add to Region
                                                                    </li>
                                                                    <li
                                                                        className="download"
                                                                        data-id="Ubuntu_app_West_John"
                                                                        onClick={ (e) => this.downloadAction(e, snapshot) }>
                                                                        <span className="icon">
                                                                            <svg
                                                                                x="0px"
                                                                                y="0px"
                                                                                viewBox="0 0 512 512"
                                                                                enableBackground="new 0 0 512 512"
                                                                                xmlSpace="preserve">
                                                                                <path
                                                                                    fillRule="evenodd"
                                                                                    clipRule="evenodd"
                                                                                    fill="#4C8CCD"
                                                                                    d="M417.2,470.3H95.6c-29.6,0-53.6-24-53.6-53.6v-80.4h53.6v80.4  h321.6v-80.4h53.6v80.4C470.8,446.3,446.8,470.3,417.2,470.3z M278.6,354.2c-3.4,3.4-7.5,5.4-11.8,6.8c-3.2,1.4-6.8,2.1-10.5,2.1  c-0.9,0-1.6-0.3-2.5-0.4c0,0-0.1,0-0.1,0c-2.2-0.2-4.4-0.5-6.4-1.3c-5.1-1.2-10.1-3.2-14.1-7.3l-102.9-103  c-11.4-11.4-11.4-29.8,0-41.2c11.4-11.4,29.8-11.4,41.2,0l58,58.1V68.3c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8v198.9  l57.2-57.2c11.4-11.4,29.8-11.4,41.2,0c11.4,11.4,11.4,29.8,0,41.2L278.6,354.2z" />
                                                                            </svg>
                                                                        </span>Download</li>
                                                                    <li
                                                                        className="delete"
                                                                        data-id="Ubuntu_app_West_John"
                                                                        onClick={ (e) => {
                                                                            this.delSnapClick(snapshot); e.stopPropagation();
                                                                        } }>
                                                                        <span className="icon">
                                                                            <svg
                                                                                x="0px"
                                                                                y="0px"
                                                                                viewBox="0 0 512 512"
                                                                                enableBackground="new 0 0 512 512"
                                                                                xmlSpace="preserve">
                                                                                <path
                                                                                    fillRule="evenodd"
                                                                                    clipRule="evenodd"
                                                                                    fill="#4C8CCD"
                                                                                    d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z" />
                                                                            </svg>
                                                                        </span>Delete</li>
                                                                </ul>
                                                            </span>
                                                        </div>
                                                    </li>

                                                ) }
                                                { this.state.nonActiveSnapshots.map((snapshot, j) =>
                                                    <li className="tr progress" key={ j }>
                                                        <div className="col col1" data-tip data-for={ snapshot.name }>{ snapshot.name }</div><ReactToolTip id={ snapshot.name } effect="solid">{ snapshot.name }</ReactToolTip>
                                                        <div className="col progress_col">Snapshot creation is in progress...</div>
                                                    </li>
                                                ) }
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </section>
                <div class={ this.state.isAddRegSlider ? "main_slider addRegionSlider active" : "main_slider addRegionSlider" }>
                    <div class="slider_bg_shadow"></div>
                    <div class="slider_wrapper">
                        <div class="main_slider_container">
                            <div className="close_icon" data-tip data-for="addRegionClose" onClick={ () => this.setState({ isAddRegSlider: false }) }></div>
                            <ReactToolTip id="addRegionClose" place='left' effect='solid' >Close</ReactToolTip>
                            <div class="imgModuleRhs_slide_wrap">
                                <div class="head_block">
                                    <h2>
                                        <span class="icon_img">
                                            <span class="icon"></span>
                                        </span>Add to Region
                                    </h2>
                                </div>
                                <div class="imgModuleRhs_content_wrap">
                                    <p class="info_txt">Select a region where you want the backup to be available</p>
                                    <div class="common_txtBox_row">
                                        <label>Regions</label>
                                        <div className={ this.state.regionContainerFocus ? "region_select_container active" : "region_select_container" }>
                                            <div className="slectBox" onClick={ () => { this.getRegionDropdown(); } }>
                                                <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" }>
                                                    <input type="text" autoComplete="off" ref={ this.uploadRegionFocus } name="uploadRegion" value={ this.state.uploadRegion } placeholder="Select a Region" onChange={ this.filterDropDown }></input>
                                                    <input type="hidden" name="regionid" value={ this.state.regionid }></input>
                                                </div>
                                                <ul>
                                                    <li className="selected_elem"><span className={ this.state.uploadRegion.length > 0 ? "country_flag " + this.state.countryName.toLowerCase() : "" }></span>{ this.state.uploadRegion.length <= 0 ? this.state.uploadRegion : this.state.uploadRegion + " (" + this.state.regionid + ")" }</li>
                                                </ul>
                                                <span className="dropArrow"> <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                    <title>drop-down</title>
                                                    <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                </svg>
                                                </span>
                                            </div>
                                            <div className="regionSelect_options">

                                                { this.state.regionListFilter.length <= 0 ?
                                                    <ul className="noSearchRes" style={ { display: this.state.regionListFilter.length <= 0 ? "" : "none" } }>
                                                        <li>No Search Found</li>
                                                    </ul>
                                                    :
                                                    <ul>
                                                        <ScrollArea
                                                            speed={ 0.8 }
                                                            style={ { maxHeight: "245px" } }
                                                            vertical={ true }
                                                            horizontal={ false }
                                                            minScrollSize={ 10 }
                                                            smoothScrolling={ false }
                                                            verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1" } }
                                                            verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                            stopScrollPropagation={ true }
                                                        >
                                                            { this.state.regionListFilter.map((region, i) =>
                                                                <li style={ { display: this.state.copyImageRegion == region.id ? "none" : "" } } className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id })<span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                                </li>
                                                            ) }

                                                        </ScrollArea>
                                                    </ul>
                                                }
                                            </div>
                                        </div>
                                        <span className="err_msg" style={ { display: this.state.regionempty ? 'inline-block' : 'none', color: "red" } } >Region cannot be blank</span>
                                    </div>
                                    <div class="cta_wrap">
                                        <input type="button" name="" value="Add" class="common_cta_btn blue" onClick={ () => this.callCopyRegion() } />
                                        <input type="button" name="" value="Cancel" class="common_cta_btn transparentGrey" onClick={ () => this.setState({ isAddRegSlider: false }) } />
                                    </div>
                                    <p><b>Note:</b> Standard charges will apply.<a href="https://www.idrivecompute.com/faq_plans.htm#additional-charges" target="_blank"> Know More</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Delete popup Start*/ }
                <div className="main_popup delete_snapshot_popup" id="snapDelPoup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.delSnapClose() }></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Delete</div>
                                </div>
                                <div className="popup_body">
                                    <p>Deleting a snapshot created for instance cloning will cause the cloning process to fail.</p>
                                    <p>Are you sure you want to delete the snapshot <b>{ this.state.selectedSnapshot.name }</b>?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button id="snapDelBtn" className="btn btn_confirm" onClick={ this.deleteSnapshot }>Delete</button>
                                        <button className="btn btn_cancel" onClick={ () => this.delSnapClose() }>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Delete popup Start*/ }

            </div>

        );
    }
}

export default Snapshot;
